var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "preEducationAlone" }, [
    _c(
      "div",
      { staticClass: "tabel-box" },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "18px",
                  "font-weight": "bold",
                  "margin-bottom": "10px",
                },
              },
              [_vm._v("前置学历复查")]
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "exit-btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.exit },
                  },
                  [_vm._v("退出登录")]
                ),
              ],
              1
            ),
          ]
        ),
        _c("div", { staticClass: "tips" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v("请上传以下三类材料之一的照片"),
          ]),
          _c("div", { staticClass: "template" }, [
            _c(
              "div",
              { staticClass: "template-item" },
              [
                _c("el-image", {
                  staticClass: "img",
                  attrs: {
                    src: require("../../../assets/images/preEducation/template1.png"),
                    fit: "contain",
                    "preview-src-list": [
                      require("../../../assets/images/preEducation/template1.png"),
                      require("../../../assets/images/preEducation/template2.jpg"),
                      require("../../../assets/images/preEducation/template3.png"),
                    ],
                  },
                }),
                _c("p", { staticClass: "text" }, [
                  _vm._v("教育部学历证书电子注册备案表"),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "template-item" },
              [
                _c("el-image", {
                  staticClass: "img",
                  attrs: {
                    src: require("../../../assets/images/preEducation/template2.jpg"),
                    fit: "contain",
                    "preview-src-list": [
                      require("../../../assets/images/preEducation/template1.png"),
                      require("../../../assets/images/preEducation/template2.jpg"),
                      require("../../../assets/images/preEducation/template3.png"),
                    ],
                  },
                }),
                _c("p", { staticClass: "text" }, [
                  _vm._v("教育部学历证书电子注册备案表"),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "template-item" },
              [
                _c("el-image", {
                  staticClass: "img",
                  attrs: {
                    src: require("../../../assets/images/preEducation/template3.png"),
                    fit: "contain",
                    "preview-src-list": [
                      require("../../../assets/images/preEducation/template1.png"),
                      require("../../../assets/images/preEducation/template2.jpg"),
                      require("../../../assets/images/preEducation/template3.png"),
                    ],
                  },
                }),
                _c("p", { staticClass: "text" }, [
                  _vm._v("教育部学历证书电子注册备案表"),
                ]),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%", "margin-top": "20px" },
            attrs: {
              "header-cell-style": { background: "#eef1f6", color: "#606266" },
              data: _vm.tableData,
              border: "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "review_status",
                label: "复查状态",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm._f("reviewStatusStyle")(
                              row.review_status
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("reviewStatusFilter")(row.review_status)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "title", label: "资料照片", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      (row.means_photo ? true : false)
                        ? _c("el-image", {
                            staticClass: "see-img",
                            attrs: {
                              src: row.means_photo,
                              fit: "contain",
                              "preview-src-list": [row.means_photo],
                            },
                          })
                        : _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "",
                                "http-request": _vm.upLoadImg,
                                "show-file-list": false,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { type: "primary", size: "small" } },
                                [_vm._v("上传资料照片")]
                              ),
                            ],
                            1
                          ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "review_remark",
                align: "center",
                label: "复查原因",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "is_check", align: "center", label: "审核状态" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: { type: _vm._f("isCheckStyle")(row.is_check) },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("isCheckFilter")(row.is_check)) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "check_user_title",
                align: "center",
                label: "审核人",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "check_at", align: "center", label: "审核时间" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "check_remark",
                align: "center",
                label: "审核备注",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "seeImage" },
      [
        _c(
          "el-dialog",
          {
            attrs: { visible: _vm.seeImageVisible },
            on: {
              "update:visible": function ($event) {
                _vm.seeImageVisible = $event
              },
            },
          },
          [
            _c("div", { staticClass: "img-box" }, [
              _c("img", {
                staticStyle: { width: "500px" },
                attrs: { src: _vm.seeImageUrl, alt: "" },
              }),
            ]),
            _c(
              "div",
              { staticClass: "btn-box" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "upload-demo",
                    attrs: {
                      action: "",
                      "http-request": _vm.upLoadImg,
                      "show-file-list": false,
                    },
                  },
                  [
                    _c("el-button", { attrs: { type: "primary" } }, [
                      _vm._v("修改资料照片"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }